import { createI18n } from 'vue-i18n'
import { messages } from '@/locales'

export { APP_LOCALES, isAppLocale, type AppLocale } from '@/locales'

/**
 * i18n. 메시지는 `scripts/build-locales.mjs` 가 Symfony 번역에서 생성한다 —
 * 손으로 고치지 않는다. 고치면 다음 생성에서 사라지고 Twig 와 문구가 갈라진다.
 *
 * **언어 목록도 생성물이다**(`@/locales`). 여기 적어 두면 번역을 늘려도 화면에
 * 안 뜨거나, 번역이 없는 언어를 고를 수 있게 된다.
 *
 * 기본 언어는 **영어**다(사용자 결정). `fallbackLocale` 도 영어라 다른 언어에 없는
 * 키는 영어로 나온다 — 키가 그대로 화면에 찍히는 것보다 낫다.
 */
export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  // 생성된 카탈로그에 `{value}` 같은 플레이스홀더가 많다. 없는 값에 경고를 쏟지 않는다.
  missingWarn: false,
  fallbackWarn: false,
})
